<script lang="ts" setup>
import type { PageElementDataOfType } from '../page-builder'

const data = defineModel<PageElementDataOfType<'heading'>>('data', {
  required: true,
})
</script>

<template>
  <div>
    <div class="flex gap-1 mb-1">
      <button
        type="button"
        class="size-8 font-medium text-lg grid place-items-center bg-white rounded border border-zinc-300"
        :class="{ '!bg-primary-500 text-white': data.size === 1 }"
        @click="data.size = 1"
      >
        H1
      </button>

      <button
        type="button"
        class="size-8 font-medium text-sm grid place-items-center bg-white rounded border border-zinc-300"
        :class="{ '!bg-primary-500 text-white': data.size === 2 }"
        @click="data.size = 2"
      >
        H2
      </button>

      <button
        type="button"
        class="size-8 font-medium text-xs grid place-items-center bg-white rounded border border-zinc-300"
        :class="{ '!bg-primary-500 text-white': data.size === 3 }"
        @click="data.size = 3"
      >
        H3
      </button>

      <button
        type="button"
        class="size-8 font-medium text-[10px] grid place-items-center bg-white rounded border border-zinc-300"
        :class="{ '!bg-primary-500 text-white': data.size === 4 }"
        @click="data.size = 4"
      >
        H4
      </button>
    </div>

    <RichTextInput v-model="data.text" :fix-height-to="40" minimal autofocus />
  </div>
</template>
